export const imageUrl = (path) => {
  return `${process.env.REACT_APP_SERVER_URL}/public/${path}`;
};
